import React from 'react';
import Paper from '@mui/material/Paper';

const acceptsFile = (file, acceptedMimeTypes) => (
  !acceptedMimeTypes?.length || acceptedMimeTypes.includes(file.type)
);

export function FileDropZone({
  acceptedMimeTypes,
  onFilesAdded,
  onFilesRejected,
  message = 'Drag and drop files, or click to select',
  elevation = 2,
  dragOverElevation = 10,
  className,
}) {
  const [dragging, setDragging] = React.useState(false);
  const inputRef = React.useRef(null);

  const processFiles = (fileList) => {
    const files = Array.from(fileList || []);
    const accepted = files.filter(file => acceptsFile(file, acceptedMimeTypes));
    const rejected = files.filter(file => !acceptsFile(file, acceptedMimeTypes));
    if (accepted.length) onFilesAdded?.(accepted);
    if (rejected.length) onFilesRejected?.(rejected);
  };

  return (
    <Paper
      className={className}
      elevation={dragging ? dragOverElevation : elevation}
      onClick={() => inputRef.current?.click()}
      onDragEnter={(event) => { event.preventDefault(); setDragging(true); }}
      onDragOver={event => event.preventDefault()}
      onDragLeave={() => setDragging(false)}
      onDrop={(event) => {
        event.preventDefault();
        setDragging(false);
        processFiles(event.dataTransfer.files);
      }}
      sx={{ cursor: 'pointer', minHeight: 96, p: 2, display: 'grid', placeItems: 'center' }}
    >
      <input
        ref={inputRef}
        hidden
        multiple
        type="file"
        accept={acceptedMimeTypes?.join(',')}
        onChange={(event) => processFiles(event.target.files)}
      />
      {message}
    </Paper>
  );
}

